var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import ReactTooltip from "react-tooltip";
import styled, { ThemeProvider } from "styled-components";
import { Body1, Body2 } from "../doconHeadings/doconHeadings";
import { doconTheme } from "../../../theme/default";
var ReactTooltipStyle = styled(ReactTooltip)(templateObject_1 || (templateObject_1 = __makeTemplateObject([" && {\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.33;\n  border-radius: 8px;\n  padding: ", ";\n\n  ", ", ", " {\n    color: currentColor;\n  }\n\n  ", " {\n    opacity: 0.8;\n    font-weight: normal;\n    /* color: rgba(255,255,255, 0.8); */\n  }\n\n  ", " ~ ", " {\n    margin-top: 4px;\n  }\n\n  &.show {\n    opacity: 1;\n  }\n}"], [" && {\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.33;\n  border-radius: 8px;\n  padding: ", ";\n\n  ", ", ", " {\n    color: currentColor;\n  }\n\n  ", " {\n    opacity: 0.8;\n    font-weight: normal;\n    /* color: rgba(255,255,255, 0.8); */\n  }\n\n  ", " ~ ", " {\n    margin-top: 4px;\n  }\n\n  &.show {\n    opacity: 1;\n  }\n}"])), function (props) { return (props.$subTitle ? "20px" : "8px 16px"); }, Body1, Body2, Body2, Body1, Body2);
function Tooltip(_a) {
    var id = _a.id, title = _a.title, subTitle = _a.subTitle, tooltipChildren = _a.tooltipChildren, props = __rest(_a, ["id", "title", "subTitle", "tooltipChildren"]);
    function renderChildren() {
        if (tooltipChildren)
            return tooltipChildren;
        if (title || subTitle) {
            return (React.createElement(React.Fragment, null,
                React.createElement(Body1, { title: title }),
                React.createElement(Body2, { title: subTitle })));
        }
    }
    return (React.createElement(ThemeProvider, { theme: doconTheme },
        React.createElement(ReactTooltipStyle, __assign({ id: id, key: id, "$subTitle": subTitle }, doconTheme.v2.colors.tooltip[props.type || 'dark'], props), renderChildren())));
}
export default styled(Tooltip)(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
var templateObject_1, templateObject_2;
